import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

class SessionExpiredDialog extends React.Component {

  handleClose = () => {
    window.location.reload()
  };

  render() {
    const { open } = this.props;

    return (


        <Dialog
          fullScreen={false}
          open={open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{"Your current session has expired!"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
            Your user session has expired, press ok to refresh your session.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>

    );
  }
}

SessionExpiredDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(SessionExpiredDialog);


// WEBPACK FOOTER //
// ./src/components/SessionExpiredDialog.js